module.exports = __webpack_public_path__ + "static/img/guide-27.072fe4f7.png";